const ITEMS = [
    "Learning",
    "Collaboration",
    "Project Delivery",
    "Innovation",
    "Performance & Recognition",
    "Engagement & Support",
];

export const Marquee = () => (
    <div
        data-testid="pillar-marquee"
        aria-hidden="true"
        className="overflow-hidden border-b border-slate-200 bg-white py-7"
    >
        <div className="animate-marquee flex w-max items-center gap-12 pr-12">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span key={i} className="flex items-center gap-12">
                    <span className="font-display whitespace-nowrap text-2xl font-semibold tracking-tight text-[#0A1B3F]/90 md:text-3xl">
                        {item}
                    </span>
                    <span className="h-2.5 w-2.5 rotate-45 bg-[#1FA187]" />
                </span>
            ))}
        </div>
    </div>
);
